// The scout's next step with one athlete, derived from their latest contact
// request. The cycle stays in-app: request → athlete answers (in-app
// notification) → chat thread. The one exception is a minor: their guardian
// answers instead, through a link we email them (guardian_pending).
//
//   kind "request" → open ContactRequestModal
//   kind "pending" → waiting on the athlete (or their guardian); not clickable
//   kind "message" → open the chat thread for this request
export const getScoutContactAction = (request) => {
  switch (request?.status) {
    case "approved":
      return { kind: "message", label: "Enviar mensaje", disabled: false };
    case "pending":
      return { kind: "pending", label: "Solicitud enviada", disabled: true };
    case "guardian_pending":
      return { kind: "pending", label: "En revisión", disabled: true };
    case "rejected":
      return { kind: "request", label: "Contactar de nuevo", disabled: false };
    default:
      return { kind: "request", label: "Contactar", disabled: false };
  }
};

export const scoutThreadPath = (request) => `/scout/messages/${request.id}`;
